<form [formGroup]="checklistColumnsForm" class="mc-spring-board" (keydown.enter)="$event.preventDefault()" (ngSubmit)="$event.preventDefault()">
  <div class="mc-spring-board-form-header mc-d-flex mc-project-checklist-columns-form-header-content">
    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Add Column</mat-label>
      <input type="text" #columnInput formControlName="addColumn" matInput maxLength="250" placeholder="Add Column" (keydown.enter)="onAddColumn()">
      <mat-hint align="end">{{ columnInput.value.length }}/250</mat-hint>
    </mat-form-field>
    <button type="button" class="mc-project-checklist-columns-form-button" mat-icon-button matTooltip="Add a Column" (click)="onAddColumn()">
      <mat-icon fontSet="project-titan" fontIcon="icon-add"></mat-icon>
    </button>
  </div>

  <div #columnList class="mc-spring-board-form-body" formArrayName="columns">
    <div class="mc-d-flex mc-project-checklist-columns-form-column" *ngFor="let column of columns.controls">
      <mat-form-field class="mc-form-field" mcColor="secondary" [formGroup]="column">
        <mat-label>Column Name</mat-label>
        <input #col type="text" formControlName="Name" matInput maxLength="250" placeholder="Column Name">
        <mat-hint align="end">{{ col.value.length }}/250</mat-hint>
      </mat-form-field>
      <button type="button" class="mc-project-checklist-columns-form-button" mat-icon-button matTooltip="Move Column Up" (click)="onMoveColumn(column.value, true)">
        <mat-icon fontSet="project-titan" fontIcon="icon-collapse"></mat-icon>
      </button>
      <button type="button" class="mc-project-checklist-columns-form-button" mat-icon-button matTooltip="Move Column Down" (click)="onMoveColumn(column.value, false)">
        <mat-icon fontSet="project-titan" fontIcon="icon-expand"></mat-icon>
      </button>
      <button type="button" class="mc-project-checklist-columns-form-button" mat-icon-button matTooltip="Remove Column" (click)="onRemoveColumn(column.value)">
        <mat-icon fontSet="project-titan" fontIcon="icon-trash"></mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="showFormFooter" class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>
    <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
    <div class="mc-form-buttons">
      <button type="button" mat-stroked-button (click)="onCancelClicked()">Cancel</button>
      <button type="submit" mat-raised-button color="primary" [disabled]="!columns.dirty" (click)="onSubmit()">Save</button>
    </div>
  </div>
</form>